// extracted by mini-css-extract-plugin
export default {"selectableCellButton":"selectableCellButton---M1aEz"};